import { render, staticRenderFns } from "./delete-confirmation-dialog.vue?vue&type=template&id=185ed215"
import script from "./delete-confirmation-dialog.vue?vue&type=script&lang=ts"
export * from "./delete-confirmation-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports